import {
	SET_FORM_STATE,
	RESET_FIELDS,
	GET_CLUSTERS_NAMES_RAN
} from '../actions/ReportsKpisActions';

const initialState = {
	clustersNames: [],
	formState: {
		values: {
		},
		isValid: false,
		touched: {},
		errors: {}
	}
};

const reportsKpisRanReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case RESET_FIELDS: {
						return {
							...state,
							drives: [],
							dates: []
						};
					}
					case GET_CLUSTERS_NAMES_RAN: {
						return {
							...state,
							clustersNames: action.clustersNames
						};
					}
					default: {
						return state;
					}
	}
};

export default reportsKpisRanReducer;
